import { render, staticRenderFns } from "./AgentCommodityCreateUpdate.vue?vue&type=template&id=aca21eb0"
import script from "./AgentCommodityCreateUpdate.vue?vue&type=script&lang=js"
export * from "./AgentCommodityCreateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports